import PaymentScreenViewController from './PaymentScreenViewController';

export default PaymentScreenViewController;
